/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsers
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsers {
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsers
     */
    restriction?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsers
     */
    detail?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsersFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsers {
    return JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsersFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsersFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsers {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'restriction': !exists(json, 'restriction') ? undefined : json['restriction'],
        'detail': !exists(json, 'detail') ? undefined : json['detail'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsersToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsers | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'restriction': value.restriction,
        'detail': value.detail,
    };
}

